var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavSimulationSvg0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 8",
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 44,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    height: 9,
    width: 2,
    x: 51,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 37,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 37,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 44,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 16,
    x: 37,
    y: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,31H41V4a1,1,0,0,0-1-1H8A1,1,0,0,0,7,4V50a1,1,0,0,0,1,1H31v9a1,1,0,0,0,1,1H58a1,1,0,0,0,1-1V32A1,1,0,0,0,58,31ZM12,8H36a1,1,0,0,1,0,2H12a1,1,0,0,1,0-2Zm0,4H36a1,1,0,0,1,0,2H12a1,1,0,0,1,0-2Zm-1,5a1,1,0,0,1,1-1H36a1,1,0,0,1,0,2H12A1,1,0,0,1,11,17ZM26,40.92V44a1,1,0,0,1-2,0V40.92A7,7,0,0,1,18,34H15a1,1,0,0,1,0-2h3.29A7,7,0,0,1,24,27.08V24a1,1,0,0,1,2,0v3.08a7,7,0,0,1,5.41,4.12A6.89,6.89,0,0,1,32,34a7,7,0,0,1-6,6.92ZM41,56H35V50h6Zm0-7H35V43h6Zm7,7H42V50h6Zm0-7H42V43h6Zm7,7H49V43h6Zm0-14H35V34H55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 34,
    r: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSimulationSvg0);
export default __webpack_public_path__ + "static/media/nav-simulation-svg-0.e8348a36f86953ff591cbd919e7737b3.svg";
export { ForwardRef as ReactComponent };